/** Tooltip copy for enrollment / assign-student dialogs — presentation only. */
export const ENROLLMENT_FIELD_HELP = {
  courseName: 'Course the learner will be enrolled in or assigned to. Cannot be changed when opened from a course context.',
  email: 'Learner email address — used for login credentials and enrollment notifications.',
  selectLearners: 'Choose which enrolled learners can access this individual assignment. Only selected learners will see it.',
};
